<template>
	<div class="wrapper">
		<headerTag />
		<div class="tsBanner">
			<img src="../../assets/images/user/tsBanner.png" alt="" class="tsBanner_img"/>
			<img src="../../assets/images/user/tsBanner_txt.png" alt="" class="tsBanner_txt" />
		</div> 
		<div class="twDiv twDiv3">
			<p>投诉内容</p>
			<textarea class="twTxt" placeholder="请简单描述您的问题（最多500字）" maxlength="500" autocomplete="off" ref="content" style="padding-bottom: 0; height: 8rem;border-radius: 0;">
				
			</textarea>
			<div class="upImg">
					 <van-uploader :before-read="beforeRead" v-model="picFile" :accept="'image/*'" :max-count="2" style="float: left;">
			         </van-uploader>
			</div>
		</div> 
		<div class="twDiv twDiv3" style="margin-bottom: 0;">
			<p>联系方式</p>
			<input type="number" placeholder="方便我们联系您(选填)" class="twNum" ref="contact"
				   autocomplete="off" maxlength="30" style="border-radius: 0;" />
		</div>
		<button class="userBtn1" @click="addComplaint" v-bind:disable="isDisable">提交</button>
		<footerTag />
	</div>

</template>

<script>
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
    import Vue from 'vue';
	import { Uploader } from 'vant';
	import { Dialog } from 'vant'
	
    export default {
    	name: 'wyTousu',
    	props: {
        	
    	},
    	data(){
		  return {
		  	isDisable:false,
		  	picFile:[],
		   	picUrlFile1:null,
		   	picUrlFile2:null,
		  }
		},
    	components: {
    		headerTag,
    		footerTag,
    		[Uploader.name]:Uploader,
    	},
    	methods:{
    		getUserInfo(){
				this.axios({
					method: 'POST',
					url:'/user/getUserName',
				}).then((res)=>{
					if(res.data.obj == null || res.data.obj == ''){
						// 用户未登录
						let currPath=window.location.href;
				  		window.location.href='/login?targetUrl='+currPath;
					}else{
						
					}
				}).catch((err)=>{
					
				})
			},
		    beforeRead(file) {
		    	/** 上传之前校验方法 **/
		      	if ((file.type != 'image/png') && (file.type != 'image/jpg') && (file.type != 'image/jpeg')) {
		        	this.$toast('请上传 png/jpg/jpeg 格式图片');
		        	return false;
		      	}
		      	// 单位B
		      	var fileSize=file.size / 1024;
		      	if(fileSize > 20480){
		      		this.$toast('图片大小不能大于20M');
		        	return false;
		      	}
		      	return true;
		    },
		   addComplaint(){
		   		let content = this.$refs.content.value;
			    if (content == "" || content == null) {
			        this.$toast('投诉内容不能为空');
			        return;
   				}
   				if(this.picFile.length > 2){
   					this.$toast('最多只能上传两张图片');
			        return;
   				}
   				if(this.picFile.length == 2){
					this.picUrlFile1=this.picFile[0].file;
	   				this.picUrlFile2=this.picFile[1].file;
				}else if(this.picFile.length == 1){
					this.picUrlFile1=this.picFile[0].file;
				}
   				let contact = this.$refs.contact.value;
   				// 构建表单
		   	   	let formData = new FormData();
      		  	formData.append('content', content);
      		  	formData.append('contact', contact);
      		   	formData.append('picUrlFile1', this.picUrlFile1);
      		   	formData.append('picUrlFile2', this.picUrlFile2);
		       	//按钮不可点击
				this.isDisable=true;
		        this.axios.post('/feedback/saveComplaintInfo', formData, 
		        	{headers: {'Content-Type': 'multipart/form-data'}
      			}).then(res => {
		        		this.isDisable=false; //按钮可点击
						if(res.data.code == 1000){
							//成功(返回到我的投诉列表)
							Dialog.alert({
							  message: '投诉成功'
							}).then(() => {
							  	this.$router.push({ name:'tousuPage' });
							});
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
			  			}else if(res.data.code == 1002){
							//置空
							this.$toast("投诉内容不能为空");
						}else if(res.data.code == 4102){
							this.$toast("投诉内容过长");
						}else{
							this.$message.error({message: '网络异常，请稍后重试'});
						}
		        }).catch(err => {
		        	this.isDisable=false; //按钮可点击
					this.$message.error({message: '网络异常，请稍后重试'});
		        })
		   }
    	},
    	mounted() {
			this.getUserInfo();
		}
    }
</script>